export default {
    // 提交数据
    setOpenId(state, value) {
        state.openid = value
        localStorage.setItem('openId', JSON.stringify(value))
    },
    setInitData(state, value) {
        state.initData = value
        localStorage.setItem('initData', JSON.stringify(value))
    }
}